import { createApp } from "vue";
import { createPinia } from "pinia";
import axios from "axios";

// 引入 Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faHeart,
  faHistory,
  faPlus,
  faTimes,
  faMagic,
  faYinYang,
  faCheckCircle,
  faUnlock,
  faChartLine,
  faStar,
  faChevronRight,
  faArrowLeft,
  faShareNodes,
  faShareAlt,
  faLeaf,
  faPaw,
  faPuzzlePiece,
  faCoins,
  faHome,
  faLightbulb,
  faEye,
  faSeedling,
  faTree,
  faRoad,
  faUsers
} from '@fortawesome/free-solid-svg-icons'

import App from "./App.vue";
import router from "./router";
import "./assets/main.css";

// 引入 Sentry
import { initSentry, initSentryReplay } from "./plugin/sentry";
import { createSentryPiniaPlugin } from "@sentry/vue";
// 引入 mixpanel
import mixpanelService from "./plugin/mixpanel";

mixpanelService.init(import.meta.env.VITE_MIXPANEL_TOKEN)

// 添加图标到库中
library.add(
  faHeart,
  faHistory,
  faPlus,
  faTimes,
  faMagic,
  faYinYang,
  faCheckCircle,
  faUnlock,
  faChartLine,
  faStar,
  faChevronRight,
  faArrowLeft,
  faShareNodes,
  faShareAlt,
  faLeaf,
  faPaw,
  faPuzzlePiece,
  faCoins,
  faHome,
  faLightbulb,
  faEye,
  faSeedling,
  faTree,
  faRoad,
  faUsers
)

const app = createApp(App)

app.config.globalProperties.$api = axios
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(createPinia().use(createSentryPiniaPlugin()));
app.use(router)

// 在开发环境中添加设备ID测试功能
if (import.meta.env.DEV) {
  import('./utils/deviceIdTest').then(({ runDeviceIdTests, getDeviceIdInfo }) => {
    // 将测试函数添加到全局window对象
    (window as any).runDeviceIdTests = runDeviceIdTests
      ; (window as any).getDeviceIdInfo = getDeviceIdInfo
    console.log('🔧 设备ID测试工具已加载到全局环境')
    console.log('💡 在控制台输入以下命令进行测试:')
    console.log('   - runDeviceIdTests()  // 运行完整测试')
    console.log('   - getDeviceIdInfo()   // 获取设备ID信息')
  }).catch(error => {
    console.warn('设备ID测试工具加载失败:', error)
  })
}

initSentry(app, import.meta.env.VITE_SENTRY_DSN, import.meta.env.VITE_SENTRY_ENVIRONMENT);
initSentryReplay();

app.mount("#app");
